class PressBlogListNew extends HTMLElement {
  constructor() {
    super();

    this.links = this.querySelectorAll(".PressBlogListNew__link");
    this.initHoverAnimation();
  }

  initHoverAnimation() {
    this.links.forEach((link) => {
      if (link.dataset.pressBlogHoverBound === "true") return;

      link.dataset.pressBlogHoverBound = "true";

      const image = link.querySelector(".PressBlogListNew__picture img");
      const arrow = link.querySelector(".PressBlogListNew__arrow");

      const animateIn = () => {
        if (!window.gsap) return;

        window.gsap.to(link, {
          backgroundColor: "#f5f5f5",
          duration: 0.3,
          ease: "power2.out",
          overwrite: "auto"
        });

        if (image) {
          window.gsap.to(image, {
            scale: 1.04,
            opacity: 0.82,
            filter: "grayscale(100%)",
            duration: 0.45,
            ease: "power2.out",
            overwrite: "auto"
          });
        }

        if (arrow) {
          window.gsap.to(arrow, {
            x: 6,
            duration: 0.3,
            ease: "power2.out",
            overwrite: "auto"
          });
        }
      };

      const animateOut = () => {
        if (!window.gsap) return;

        window.gsap.to(link, {
          backgroundColor: "transparent",
          duration: 0.3,
          ease: "power2.out",
          overwrite: "auto",
          clearProps: "backgroundColor"
        });

        if (image) {
          window.gsap.to(image, {
            scale: 1,
            opacity: 1,
            filter: "grayscale(0%)",
            duration: 0.45,
            ease: "power2.out",
            overwrite: "auto",
            clearProps: "transform,opacity,filter"
          });
        }

        if (arrow) {
          window.gsap.to(arrow, {
            x: 0,
            duration: 0.3,
            ease: "power2.out",
            overwrite: "auto",
            clearProps: "transform"
          });
        }
      };

      link.addEventListener("mouseenter", animateIn);
      link.addEventListener("focus", animateIn);
      link.addEventListener("mouseleave", animateOut);
      link.addEventListener("blur", animateOut);
    });
  }
}

if (!customElements.get("press-blog-list")) {
  customElements.define("press-blog-list", PressBlogListNew);
}
